export interface ReviewItem {
  id: string;
  name: string;
  role: string;
  text: string;
}

export const reviews: ReviewItem[] = [
  {
    id: "rv-01",
    name: "一只爱看热闹的橘猫",
    role: "追瓜网友",
    text: "以前吃瓜全靠自己几个平台来回翻，还老吃不全。现在一条时间线就能从起因看到结果，关键还分清楚哪些是实锤哪些只是说法，省心太多了。",
  },
  {
    id: "rv-02",
    name: "新闻系在读生",
    role: "内容学习者",
    text: "最喜欢它把「已确认 / 双方说法 / 尚未证实」标得清清楚楚，这比某些为了流量乱带节奏的内容专业多了，用来练信息辨别正好。",
  },
  {
    id: "rv-03",
    name: "傍晚散步的Danny",
    role: "普通网友",
    text: "发生反转的时候它会补更新，还会标注前一个版本的说法，不会假装自己一直都对。这种坦诚让人挺安心的。",
  },
];